import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useMantineTheme } from '@mantine/styles';
import { getArrowPositionStyles } from './get-arrow-position-styles.js';

var _excluded = ["position", "arrowSize", "arrowOffset", "arrowRadius", "arrowPosition", "visible", "arrowX", "arrowY"];
var FloatingArrow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var position = _ref.position,
    arrowSize = _ref.arrowSize,
    arrowOffset = _ref.arrowOffset,
    arrowRadius = _ref.arrowRadius,
    arrowPosition = _ref.arrowPosition,
    visible = _ref.visible,
    arrowX = _ref.arrowX,
    arrowY = _ref.arrowY,
    others = _objectWithoutProperties(_ref, _excluded);
  var theme = useMantineTheme();
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", _objectSpread2(_objectSpread2({}, others), {}, {
    ref: ref,
    style: getArrowPositionStyles({
      position: position,
      arrowSize: arrowSize,
      arrowOffset: arrowOffset,
      arrowRadius: arrowRadius,
      arrowPosition: arrowPosition,
      dir: theme.dir,
      arrowX: arrowX,
      arrowY: arrowY
    })
  }));
});

export { FloatingArrow };
//# sourceMappingURL=FloatingArrow.js.map
